import { render, staticRenderFns } from "./request-stats.vue?vue&type=template&id=a44c66c0&scoped=true&"
import script from "./request-stats.vue?vue&type=script&lang=js&"
export * from "./request-stats.vue?vue&type=script&lang=js&"
import style0 from "./request-stats.vue?vue&type=style&index=0&id=a44c66c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a44c66c0",
  null
  
)

export default component.exports